


















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Config from '@/config';
import SetupStatus, { StatusEnum } from '@/models/SetupStatus';
import { mapGetters } from 'vuex';
import clients from '@/store/modules/clients';
import users from '@/store/modules/users';
import moment from 'moment';
import Client from '../../models/Client';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class Summary extends Vue {
  private clientsList: Client[] = [];
  private statusEnum = StatusEnum;
  private statusList: SetupStatus[] = [];
  private loading = true;
  private isAuthenticated;
  private totalRows = 1;
  private perPage = 10;
  private currentPage = 1;
  private tableItems: any[] = [];
  private modalTitle = '';
  private modalBody = '';
  private showModal = false;
  private deleteModal = false;
  private editModal = false;
  private clientToDelete: any;
  private clientToEdit: any;
  private tableKey = 0;

  private statusOptions = [
    { value: 'BILLING', text: 'BILLING' },
    { value: 'ERROR', text: 'ERROR' },
    { value: 'PENDING', text: 'PENDING' },
    { value: 'QUEUED', text: 'QUEUED' },
    { value: 'RUNNING', text: 'RUNNING' },
    { value: 'CLONED', text: 'CLONED' },
    { value: 'DEV-CONFIGURED', text: 'DEV-CONFIGURED' },
    { value: 'API-DEV-CONFIGURED', text: 'API-DEV-CONFIGURED' },
    { value: 'PROCESSED', text: 'PROCESSED' },
  ];

  private fields = [
    { key: 'last invoice', sortable: true },
    { key: 'client', sortable: true },
    { key: 'step', sortable: true },
    { key: 'status', sortable: true },
    { key: 'actions', label: 'Actions' },
  ];

  private async mounted() {
    try {
      const user = await users.getLoggedUser();
      if (!user) {
        await users.logout();
        this.$router.push({ name: 'login' });
      } else {
        await this.prepareComponent();
      }
    } catch (error) {
      return error;
    }
  }

  private async prepareComponent() {
    try {
      this.clientsList = await clients.getClients();
      this.totalRows = this.clientsList.length;
      this.loading = false;
      this.tableKey++;
      this.$forceUpdate();
    } catch (error) {
      return error;
    }
  }

  private details(row) {
    this.modalTitle = 'Error details';
    this.modalBody = row.item.error;
    this.showModal = true;
  }

  private beforeUpdate() {
    this.tableKey++;
    this.tableItems = this.convertToItems();
  }

  private async editBillingInfo(row) {
    this.$router.push({
      name: 'billing',
      params: { client: row.item },
    });
  }

  private editStatus(row) {
    console.log(row.item);
    this.modalBody = `Do you want to edit status of ${row.item.client}?`;
    this.clientToEdit = row.item;
    this.editModal = true;
  }

  private deleteClient(row) {
    this.modalTitle = `Delete client`;
    this.modalBody = `Do you really want to delete ${row.item.client}?`;
    this.clientToDelete = row.item;
    this.deleteModal = true;
  }

  private async performDelete() {
    await clients.deleteClient({ clientId: this.clientToDelete.holded.id });
    this.$forceUpdate();
  }

  private async performEdition() {
    this.clientToEdit.holded.setupStatus.status = this.clientToEdit.status;
    await clients.editClient({
      clientId: this.clientToEdit.holded.id,
      data: this.clientToEdit.holded,
    });
    this.$forceUpdate();
  }

  private async generateInvoice(item) {
    this.loading = true;
    const response = await clients.generateInvoice(item);
    this.modalTitle = 'Invoice generated successfully';
    this.modalBody = `The invoice of client ${item.restaurantName} was generated successfully`;
    this.loading = false;
    this.showModal = true;
  }

  private convertToItems() {
    // TODO: Review if everything works ok with Arthur's approach =>

    const items =
      this.clientsList !== undefined && this.loading !== true
        ? this.clientsList.map((element) => {
            return {
              'last invoice': moment(element.createdAt).format('DD MMM yyyy'),
              client: element.restaurantName,
              step: element.setupStatus.step,
              status: element.setupStatus.status,
              error: element.setupStatus.error,
              holded: element,
            };
          })
        : [];
    return items;
    // return this.statusList !== undefined && this.loading !== true
    //   ? this.statusList.map((element) => {
    //       return {
    //         id: element.id,
    //         date: moment(element.createdAt).format('DD MMM yyyy'),
    //         client: element.client?.restaurantName,
    //         step: element.step,
    //         status: element.status,
    //         error: element.error,
    //         holded: element,
    //       };
    //     })
    //   : [];
  }
}
